import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, Typography, Avatar, colors, Button } from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.white,
    // backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  details: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  
  label: {
    marginLeft: theme.spacing(1)
  },
  
  avatar: {
    backgroundColor: theme.palette.white,
    color: theme.palette.primary.main,
    height: 48,
    width: 48
  }
  
  

}));

export default function BlockCard(props) {

    const { className, ...rest } = props;

    const classes = useStyles();

    const data = {
        value: '24,000',
        currency: '$',
    };
    
    return (

      <Card
          {...rest}
          className={clsx(classes.root, className)}
      >
        <div>
            <Typography
                component="h3"
                gutterBottom
                variant="overline"
            >
                LOREM IPSUM
            </Typography>
            <div className={classes.details}>
                <Typography variant="h4">
                {data.currency}
                {data.value}
                </Typography>
                
            </div>
        </div>
        <Avatar
          className={classes.avatar}
          color="inherit"
        >
          <AttachMoneyIcon />
        </Avatar>
        
      </Card>
    );
}